
export enum SituacaoInstalacaoPontoPromocional {
  NaoInstalado = 'NaoInstalado',
  Instalado = 'Instalado',
  Desinstalado = 'Desinstalado',
}
